import React, { useState, useEffect } from "react";
import "./Orders.css";
import { useLocation } from "react-router-dom";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Orders = ({ orders }) => {
  const [isFocused, setIsFocused] = useState(false);
  const location = useLocation();
  const [searchno, setsearchno] = useState("");

  const navigate = useNavigate();

  const handlesearch = (e) => {
    e.preventDefault();

    const trimmed = searchno.trim();

    if (!trimmed) {
      console.warn("Empty search value");
      return;
    }

    const result = orders.filter(
      (item) =>
        String(item.tracking_number).replace(/^#/, "") ===
        String(trimmed).replace(/^#/, "")
    );

    console.log("Search for:", trimmed, "Results:", result);

    if (result.length > 0) {
      const raw = result[0].tracking_number;
      const cleanTracking = raw.startsWith("#") ? raw.slice(1) : raw;

      navigate(`orders/orderid/${cleanTracking}`, {
        state: { order: result[0] },
      });
    } else {
      console.warn("Order not found");
    }
  };

  useEffect(() => {
    console.log("Loaded orders:", orders);
  }, [orders]);

  return (
    <div>
      {location.pathname === "/vendor/orders" ? (
        <h1 className="dashboard-heading">New Orders</h1>
      ) : location.pathname === "/vendor/vendordashboard" ? (
        <div className="report-title">📋 Order Reports</div>
      ) : null}

      {location.pathname !== "/vendor/vendordashboard" && (
        <form className="glow-search-container" onSubmit={handlesearch}>
          <input
            type="text"
            className="glow-search-input"
            placeholder="Find your Orders, fast..."
            value={searchno}
            onChange={(e) => setsearchno(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
          <span
            className={`search-icon ${isFocused ? "animate" : ""}`}
            onClick={handlesearch}
          >
            <IoSearch />
          </span>
        </form>
      )}

      <div
        className="report-container"
        style={{
          background:
            location.pathname === "/vendor/vendordashboard"
              ? "#f9f9ff"
              : "transparent",
        }}
      >
        <table className="report-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Order ID</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Address</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((item, index) => (
              <tr key={item.order_id}>
                <td>{index + 1}</td>
                <td>{item.tracking_number}</td>
                <td>{item.cust_name}</td>
                <td>{item.order_date}</td>
                <td>{item.ship_add}</td>
                <td>{item.total_amount}</td>
                <td>
                  <span
                    className={`status ${item.order_status
                      .toLowerCase()
                      .replace(" ", "-")}`}
                  >
                    {item.order_status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Orders;
